import React from 'react'
import Button from '../components/Button'

const CompPopUp = (props) => {
  return (
    <div className='compZonepopup'>
      <div className='compPopUpWidth'>
        <Button
        clickFunction={props.closeRadioPopUpf} 
        classList="closePopup"
        >
        &#10005;
        </Button>

        <div className='popupContent'>
          <p>The Under-the-Counter Pedestals is not compatible in <b>front side</b> with <b>SWA2450GS</b> wallOven
          {/* <br></br><br></br>The Under-the-Counter Pedestals in <b>Zone 7</b> is only compatible with <b>SSC2489GS</b> wallOven */}
          </p>
          <Button
          classList="compPopUp"
          clickFunction={props.closeRadioPopUpf}
          >OK</Button>
        </div>

      </div>
    </div>
  )
}

export default CompPopUp